import { useEffect, useState } from 'react';
import { LifeBuoy, Send, ExternalLink } from 'lucide-react';

// Browser-safe landing that jumps into the Telegram APP (tg:// scheme) to complete
// the support-app account binding. Works where the t.me web page is blocked (KZ ISPs).
function TgSupportRedirect() {
  const params = new URLSearchParams(window.location.search);
  const bot = (params.get('bot') || '').replace(/[^a-zA-Z0-9_]/g, '');
  const token = (params.get('t') || '').replace(/[^a-zA-Z0-9_-]/g, '');
  const tgUrl = `tg://resolve?domain=${bot}&start=${token}`;
  const tmeUrl = `https://t.me/${bot}?start=${token}`;
  const [tried, setTried] = useState(false);

  useEffect(() => {
    if (!bot || !token) return;
    // Best-effort auto-launch of the Telegram app (may require a user tap on some browsers).
    const timer = setTimeout(() => { window.location.href = tgUrl; setTried(true); }, 400);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);

  const invalid = !bot || !token;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-sky-50 to-white p-6" data-testid="tg-support-redirect">
      <div className="w-full max-w-sm text-center">
        <div className="w-16 h-16 rounded-2xl bg-sky-600 flex items-center justify-center mx-auto mb-5">
          <LifeBuoy className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Поддержка Ainanan</h1>

        {invalid ? (
          <p className="text-sm text-gray-500" data-testid="tg-support-invalid">
            Ссылка неполная. Попросите администратора выдать её заново.
          </p>
        ) : (
          <>
            <p className="text-sm text-gray-600 mb-6">
              Доступ открывается в приложении <b>Telegram</b>. Нажмите кнопку ниже —
              откроется бот и активирует ваш доступ.
            </p>

            <a href={tgUrl} data-testid="tg-support-open-app"
               className="flex items-center justify-center gap-2 w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-xl py-3.5 transition-colors">
              <Send className="w-5 h-5" /> Открыть в Telegram
            </a>

            <a href={tmeUrl} target="_blank" rel="noopener noreferrer" data-testid="tg-support-fallback"
               className="flex items-center justify-center gap-1.5 w-full text-sky-700 text-sm mt-4 py-2">
              <ExternalLink className="w-4 h-4" /> Не открылось? Открыть через t.me
            </a>

            <p className="text-xs text-gray-400 mt-6">
              Важно: ссылку нужно открывать на телефоне, где установлен Telegram.
              {tried ? ' Если ничего не произошло — нажмите синюю кнопку.' : ''}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default TgSupportRedirect;
